const WHITELIST = [
  "en-us",
  "en-US",
  "pt-br",
  "pt-BR",
  "fr-fr",
  "fr-FR",
  "sv-se",
  "sv-SE"
];

export default () => {
  let LOCALE =
    navigator.language ||
    (navigator.languages && navigator.languages[0]) ||
    navigator.userLanguage;

  LOCALE = (LOCALE && LOCALE.toLowerCase()) || LOCALE;

  if (WHITELIST.indexOf(LOCALE) < 0) {
    LOCALE = "en-us";
  }

  return LOCALE;
};



// WEBPACK FOOTER //
// ./src/utils/locale.js